import { Link } from "@tanstack/react-router";

import type { SKUStoreResourceCardPrimaryAction } from "@/features/SKUStore/components/ResourceCard/SKUStoreResourceCard.types";

/** Spread onto a MUI `Button` so a primary action with `link` renders as a router link. */
export function primaryActionLinkProps(
  action: SKUStoreResourceCardPrimaryAction,
) {
  return action.link ? { component: Link, ...action.link } : {};
}
